import request from '@/utils/request'
import base from "@/api/base";

export default {
    // 查询所有用户
    username: params => request.post(`${base.baseUrl}/yyyhao-cloud-system/user/getUserNotPerm`, params),
    //根据用户查询菜单权限
    userqx: params => request.post(`${base.baseUrl}/yyyhao-cloud-system/menu-permission/getMenuPermissionsByUser`, params),
    //新增菜单权限
    addqx: params => request.post(`${base.baseUrl}/yyyhao-cloud-system/menu-permission/saveMenuPermission`, params),
    //删除菜单权限
    delqx: params => request.post(`${base.baseUrl}/yyyhao-cloud-system/menu-permission/deleteMenuPermission`, params),
}